import gql from "graphql-tag";
import { Location } from "../../api/schema";

export interface LocationListResponse {
  locations: Array<Location>;
}

export interface DeleteLocationResponse {
  deleteLocation: boolean;
}

export interface CreateLocationState {
  name: string;
  parent: Location | null;
}

export interface CreateLocationResponse {
  createLocation: { id: number };
}

export interface UpdateLocationResponse {
  updateLocation: { id: number };
}

export const LocationListQuery = gql`
  query locations {
    locations {
      id
      name
      parent {
        id
        name
        parent {
          id
          name
        }
      }
    }
  }
`;

export const CreateLocationMutation = gql`
  mutation createLocation($values: CreateLocationInput!) {
    createLocation(values: $values) {
      id
    }
  }
`;

export const UpdateLocationMutation = gql`
  mutation updateLocation($values: UpdateLocationInput!) {
    updateLocation(values: $values) {
      id
    }
  }
`;

export const DeleteLocationMutation = gql`
  mutation deleteLocation($id: ID!) {
    deleteLocation(id: $id)
  }
`;
